module.exports = __webpack_public_path__ + "static/media/view4.c1a8071e.jpg";